const main = {
  inactive: "rgb(211, 211, 211)",
  primaryButton: "rgb(0, 0, 255)",
  mainText: "rgb(0, 0, 0)",
  detailText: "rgb(255, 255, 255)",
  secondaryColor: "rgb(255,0,0)",
  background: "rgb(255, 255, 255)",
  overlayBackground: "rgb(211, 211, 211)",
  overlayDetail: "rgb(169,169,169)"
};

const dark = {
  inactive: "rgb(120, 120, 120)",
  primaryButton: "rgb(0, 0, 255)",
  mainText: "rgb(255, 255, 255)",
  detailText: "rgb(255, 255, 255)",
  secondaryColor: "rgb(255,0,0)",
  background: "rgb(40, 40, 40)",
  overlayBackground: "rgb(40, 40, 40)",
  overlayDetail: "rgb(68,68,68)"
};

const colors = {
  main: main,
  dark: dark
};

export default colors;
